import {
  Box,
  Grid,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Select,
} from "@mui/material";
import React from "react";
import {
  Edit,
  ImageField,
  SelectField,
  SelectInput,
  SimpleForm,
  useRecordContext,
  useRefresh,
} from "react-admin";
import LinkToBankProducts from "../partners/LinkToBankProducts";
import HmTextInput from "../unit/HmTextInput";
import formatPhone from "../unit/inputFormat/formatPhone";
import parseNumber from "../unit/inputFormat/parseNumber";
import parsePhone from "../unit/inputFormat/parsePhone";
import validateNumber from "../unit/inputFormat/validateNumber";
import YesNoInput from "../unit/YesNoInput";
import useNotify from "../unit/useNotify";
import sendRequest from "../dataProvider/sendRequest";
import { CopyAllOutlined } from "@mui/icons-material";
import RefreshIcon from "@mui/icons-material/Refresh";
import CustomSelect from "../unit/forms/CustomSelect";
import UploadImage from "../unit/UploadImage";
const ShowOriginalName = () => {
  const record = useRecordContext();
  return (
    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
      {record?.sName}
    </Typography>
  );
};

const CampaignLink = ({ ...props }) => {
  const record = useRecordContext();
  const id = record?.id;
  const [campaignLink, setCampaignLink] = React.useState(record?.sUrl || "");
  const { success } = useNotify();
  const handleClick = () => {
    let reqUrl = "general/campaignlink";
    sendRequest(reqUrl, { id: id }).then((response) => {
      if (response) {
        setCampaignLink(response?.url);
      }
    });
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(campaignLink);
    success("Link copied to clipboard");
  };
  return (
    <Box>
      <TextField
        id="outlined-basic"
        label="Campaign URL"
        variant="outlined"
        value={campaignLink}
        sx={{
          width: "100%",
          "& input.Mui-readOnly": {
            backgroundColor: "#ddd",
            borderRadius: "10px",
          },
        }}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={"Generate URL"}
                onClick={handleClick}
                edge="end"
                disabled={campaignLink ? true : false}
              >
                <RefreshIcon color={campaignLink ? "disabled" : "primary"} />
              </IconButton>

              {/* <IconButton
                aria-label={"Copy URL"}
                onClick={handleCopy}
                edge="end"
                sx={{ marginLeft: "20px" }}
              >
                <CopyAllOutlined color="primary" />
              </IconButton> */}
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

const CampaignLogo = ({ ...props }) => {
  const record = useRecordContext();
  if (!record) {
    return null;
  }
  const [logo, setLogo] = React.useState(record?.sLogo || "");
  const refresh = useRefresh();
  const [filelist, setFilelist] = React.useState<any[]>([]);

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: "10px", mb: "20px" }}
    >
      <Typography variant="subtitle1">
        <b>Square logo</b> (as brand image shown on the top banner of customer
        site. Tip: Use logo for Twitter account)
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          mb: "20px",
          "& .RaImageField-image": {
            height: "100px !important",
            width: "auto !important",
            objectFit: "contain",
          },
          "& > div": {
            height: "80px",
            display: "flex",
            alignItems: "center",
          },
        }}
      >
        <>
          {logo && (
            <img
              src={logo}
              style={{
                maxWidth: "200px",
                objectFit: "contain",
              }}
            />
          )}
          <Box sx={{ width: "100%", height: "50px", ml: "0px" }}>
            <UploadImage
              uploadName="campaignLogo"
              uploadApi={"campaigns/actions/uploadLogo/" + record?.id}
              showFileList={false}
              onSuccess={(lastfile: any) => {
                console.log("File uploaded successfully", lastfile);
                setLogo(lastfile);
                refresh();
              }}
            />
          </Box>
        </>
      </Box>
    </Box>
  );
};
const CampaignEdit = (props: any) => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [securitySignup, setSecuritySignup] = React.useState("");
  const [signLanguage, setSignLanguage] = React.useState("en");
  const [showEditAccountSection, setShowEditAccountSection] =
    React.useState(false);
  const curTab = props?.curTab;
  const productList = props?.productList;
  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Edit
      {...props}
      basePath="/campaigns"
      resource="campaigns"
      sx={{
        marginTop: "0px",
        ".MuiPaper-root": { border: "none", borderRadiue: "none" },
      }}
      className="campaign_edit_dialog_form"
    >
      <SimpleForm toolbar={false} sx={{ paddingTop: "0px" }}>
        <Box sx={{ width: "100%", pt: 0 }}>
          <>
            {curTab && curTab == "info" && (
              <Box
                sx={{
                  pt: 0,
                  pb: 2,
                }}
                id="campaign-edit-info-tab"
              >
                <HmTextInput source="sName" label="Page Name" required={true} />
                <SelectInput
                  sx={{ mt: 1 }}
                  variant="outlined"
                  source="sign_language"
                  label="Sign-Up Page Language"
                  choices={[
                    { id: "en", name: "English" },
                    {
                      id: "es",
                      name: "Spanish",
                    },
                    {
                      id: "ps",
                      name: "Pashto",
                    },
                  ]}
                  required={true}
                  helperText={false}
                />
                <HmTextInput
                  source="sSlogan"
                  label="Welcome Headline"
                  required={true}
                />
                <HmTextInput
                  source="sWelcomeMsg"
                  label="Welcome Message"
                  rows={6}
                  multiline={true}
                  required={true}
                />
                <SelectInput
                  source="security_signup"
                  label="Sign-Up Method"
                  variant="outlined"
                  choices={[
                    { id: "standard", name: "Standard" },
                    {
                      id: "counselor_assisted",
                      name: "Counselor Assisted",
                    },
                  ]}
                  required={true}
                  helperText={false}
                />

                <CampaignLink />
              </Box>
            )}
            {curTab && curTab == "special" && (
              <Box
                sx={{
                  pt: 2,
                  pb: 2,
                }}
                id="campaign-edit-special-tab"
              >
                <CampaignLogo />
              </Box>
            )}
            {curTab && curTab == "linkProducts" && (
              <Box
                sx={{
                  pt: 2,
                  pb: 2,
                }}
                id="campaign-edit-linkproducts-tab"
              >
                <LinkToBankProducts productList={productList} />
              </Box>
            )}
            {curTab && curTab == "uniqueURL" && (
              <Box
                sx={{
                  pt: 2,
                  pb: 2,
                  width: "100%",
                }}
                id="campaign-edit-uniqueurl-tab"
              >
                {/* <CampaignLink /> */}
              </Box>
            )}
          </>
        </Box>
      </SimpleForm>
    </Edit>
  );
};

export default CampaignEdit;
